var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFeher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "T-DOC_logo_H_szines",
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 46.001,
    viewBox: "0 0 140 46.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5094",
    transform: "translate(55.552 13.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    d: "M1915.957,1097.113h-6.046v-3.1h15.469v3.1h-6.046v15.959h-3.377Z",
    transform: "translate(-1909.911 -1093.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    d: "M1930.408,1106.221h8.061v3.241h-8.061Z",
    transform: "translate(-1915.142 -1096.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    d: "M1945.443,1094.008h7.108c5.991,0,10.13,4.112,10.13,9.477v.054c0,5.365-4.139,9.532-10.13,9.532h-7.108Zm3.35,3.05v12.963h3.758a6.213,6.213,0,0,0,6.617-6.427v-.055a6.255,6.255,0,0,0-6.617-6.481Z",
    transform: "translate(-1918.979 -1093.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    d: "M1970.859,1103.483v-.055a9.969,9.969,0,0,1,19.936-.054v.054a9.969,9.969,0,0,1-19.936.055Zm16.422,0v-.055a6.531,6.531,0,0,0-6.482-6.78,6.44,6.44,0,0,0-6.427,6.726v.054a6.508,6.508,0,0,0,6.481,6.754A6.418,6.418,0,0,0,1987.281,1103.483Z",
    transform: "translate(-1925.466 -1093.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    d: "M1999.895,1103.483v-.055a9.647,9.647,0,0,1,9.832-9.858,9.936,9.936,0,0,1,7.462,2.968l-2.152,2.479a7.579,7.579,0,0,0-5.338-2.369,6.416,6.416,0,0,0-6.291,6.726v.054c0,3.731,2.642,6.754,6.291,6.754a7.447,7.447,0,0,0,5.474-2.451l2.152,2.178a9.836,9.836,0,0,1-7.735,3.377A9.588,9.588,0,0,1,1999.895,1103.483Z",
    transform: "translate(-1932.877 -1093.57)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    d: "M1875.443,1085.047v10.218l-1.941-.146c-1.126-.09-2.253-.155-3.38-.231l-3.382-.2a.9.9,0,0,0-.812.417l-.059.093-2.047,3.27-.085.138-.177-1.05-.805-4.577-.831-4.568-.862-4.562a1.873,1.873,0,0,0-3.614-.256l-.017.051-1.937,5.68-1.9,5.7-1.574,4.847-.515-2.214c-.347-1.5-.719-3-1.076-4.492s-.738-2.991-1.1-4.487l-.028-.115a1.36,1.36,0,0,0-2.535-.276l-1.718,3.45-1.458,2.98-2.785.164c-1.147.076-2.29.146-3.434.234l-2.047.155v-10.215a9.124,9.124,0,0,1,9.125-9.123h21.87A9.124,9.124,0,0,1,1875.443,1085.047Z",
    transform: "translate(-1835.322 -1075.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    d: "M1875.443,1101.4v10.815a9.126,9.126,0,0,1-9.058,9.126v5.883l-5.884-5.883h-16.054a9.125,9.125,0,0,1-9.125-9.126V1101.4l2.047.155c1.143.088,2.287.155,3.434.234l3.432.2a.916.916,0,0,0,.825-.428l.06-.093,2.042-3.27.059-.1q.081.489.169.98c.264,1.515.518,3.033.8,4.548l.831,4.543.855,4.537a1.879,1.879,0,0,0,3.625.259l.017-.051,1.932-5.683,1.892-5.7,1.581-4.866.532,2.283,1.083,4.518,1.116,4.509.028.116a1.345,1.345,0,0,0,2.506.272l1.721-3.45,1.467-2.988,2.746-.164c1.127-.079,2.254-.141,3.38-.231Z",
    transform: "translate(-1835.322 -1081.221)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFeher);
export default __webpack_public_path__ + "static/media/logo_feher.03d5a8c3e0dec1653900bc0f6e0f670f.svg";
export { ForwardRef as ReactComponent };